import LinkWrapper from 'components/Common/LinkWrapper';
import Svg from 'UI/components/Svg';
import ClutchWidget from 'UI/components/ClutchWidget';
import cn from 'classnames';
import { routes } from 'utils/routes';
import styles from './styles.module.scss';
import { SERVICES, SERVICES_FULL } from '../../utils/headerConstants';
import { NavItem } from '../NavItem';

const ServiceMenu = ({ isLightTheme, isPageScrolledDown }) => (
  <div className={cn(styles.dropdownContainer, { [styles.light]: isLightTheme || isPageScrolledDown })}>
    <div className={styles.contentContainer}>
      <div className={styles.leftContent}>
        <p className={styles.serviceTitle}>
          We deliver services that drive your business growth
        </p>
        <div className={styles.clutchContainer}>
          <p>Read our Clutch reviews</p>
          <ClutchWidget isLight={isLightTheme || isPageScrolledDown} />
        </div>
        <LinkWrapper
          isLocalLink
          path={routes.services.path}
          className={styles.seeAllButton}
        >
          <span>See All Services</span>
        </LinkWrapper>
      </div>
    </div>
    <div className={styles.ourWorkContent}>
      <div>
        <div className={styles.linksContainer}>
          {SERVICES.map(({ icon, title, path }) => (
            <NavItem
              title={title}
              icon={icon}
              path={path}
            />
          ))}
        </div>
      </div>
      <div>
        <div className={styles.linksContainer}>
          {SERVICES_FULL.map(({ icon, title, path }) => (
            <NavItem
              title={title}
              icon={icon}
              path={path}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default ServiceMenu;
